// extracted by mini-css-extract-plugin
export var gif = "_k4-0";